if(document.dir === 'rtl') Mutate();

function Mutate(){
    new MutationObserver((mutationList, observer) => {
        const shopify_form = document.querySelector("shopify-forms-embed");
        if(shopify_form){
            manipulateForm(shopify_form);
            observer.disconnect();
        }
    }).observe(document.documentElement, { childList: true, subtree: true});
}


function manipulateForm(form){
    if(!form.shadowRoot) return console.log("No shadowRoot");

    const stylesheet = new CSSStyleSheet();
    stylesheet.replaceSync(`
        * { font-family: inherit !important }
        div[class^="_formFieldContainer"] { text-align: start } 
        div[class^="_formFieldContainer"] label { top: 16px; left: auto; right: var(--form-field-padding); -webkit-transform-origin-x: right; }
    `);
    form.shadowRoot.adoptedStyleSheets = [...form.shadowRoot.adoptedStyleSheets, stylesheet]
}

